import { Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { InfoBubble } from '~/@ui/info-bubble/InfoBubble'
import { StyledSlider } from '~/@ui/slider/StyledSlider'
import { SummaryPensionValues } from './SummaryPensionValues'
import { calculateInvestmentProjections } from '~/@ui/chart/_utils/investmentCalculator'

type Props = {
  series: ReturnType<typeof calculateInvestmentProjections>
  theme?: 'light' | 'dark'
  className?: string
}

export const GraphSummaryPension = ({
  series,
  theme = 'dark',
  className = '',
}: Props) => {
  const [sliderValue, setSliderValue] = useState(15)

  const lightMode = theme === 'light'

  return (
    <Stack className={`gap-3 ${className}`}>
      <Stack
        className={`p-4 pr-4 ${lightMode ? 'bg-zGrey200' : 'bg-zBlack300'} rounded-4d`}>
        <Stack className="flex-row items-center gap-1">
          <InfoBubble text="Odhadnite, o koľko rokov chcete začať čerpať rentu. Nie je to záväzné – rentu môžete vybrať skôr alebo neskôr (max. do 30 rokov)." />
          <Typography
            className={`text-base font-bold ${lightMode ? 'text-zBlack200' : 'text-zWhite200'}`}>
            Kedy chete ísť do dôchodku
          </Typography>
          <Typography
            className={`flex-shrink-0 text-[22px] font-black ${lightMode ? 'text-zBlack200' : 'text-zWhite200'}`}>
            {`${sliderValue} rokov`}
          </Typography>
        </Stack>

        <Stack className="px-4">
          <StyledSlider
            darkTheme={lightMode} //TODO <- opravit toto nazvove opozitum
            min={0}
            max={40}
            step={1}
            value={sliderValue}
            onChange={(_, newSliderValue) => {
              if (typeof newSliderValue === 'number') {
                setSliderValue(newSliderValue)
              }
            }}
          />
        </Stack>
      </Stack>

      <SummaryPensionValues
        theme={theme}
        deposit={series.cashValue[sliderValue * 12]}
        earlyWithdraw={series.earlyWithdrawValue[sliderValue * 12] || 0}
        bonaship={series.bonashipValue[sliderValue * 12] || 0}
      />
    </Stack>
  )
}
